// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetAllFacets = (dealerAccounts, metrics, pipTypes) => ({
    dealerAccounts,
    metrics,
    pipTypes,
    type: actions.RESET_OPEN_PIP_PRODUCTS_FILTERS
});

export const selectAllDealersOnInitialLoad = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.SELECT_ALL_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS
        });

        dispatch({
            allowedDealers,
            type: actions.INITIALIZE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM
        });

    };

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS
});

export const togglePipTypeFacetItems = allowedTypes => ({
    allowedTypes,
    type: actions.TOGGLE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEMS
});

export const toggleMetricsFacetItems = allowedMetrics => ({
    allowedMetrics,
    type: actions.TOGGLE_OPEN_PIP_PRODUCTS_METRICS_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_OPEN_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM
});

export const updateMetricFacetItem = (metric, isSelected) => ({
    isSelected,
    metric,
    type: actions.UPDATE_OPEN_PIP_PRODUCTS_METRIC_FACET_ITEM
});

export const updatePipTypeFacetItem = (pipType, isSelected) => ({
    isSelected,
    pipType,
    type: actions.UPDATE_OPEN_PIP_PRODUCTS_PIP_TYPE_FACET_ITEM
});



// WEBPACK FOOTER //
// ./src/pip/open-pips/action-creators/facets.js